import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Toolbar from './components/toolbar/Toolbar';
import { BrowserRouter } from 'react-router-dom';
import Routs from './components/routs/Routs';
import Footer from './components/footer/footer';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Toolbar/>
      <Routs/>
      <Footer/> 
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
